
        import * as module0 from '$components/shared/site_footer.css';import * as module1 from '$components/shared/site_header.css';import * as module2 from '$components/shared/site_header.js'
        const modules = {
            "shared/site_footer.css": module0,
            "shared/site_header.css": module1,
            "shared/site_header.js": module2,
        };
        export default modules;
      